import io from 'socket.io-client';

let socket = null;
let isConnected = false;

export const connectSocket = () => {
    if (!isConnected) {
        let user = JSON.parse(localStorage.getItem('userData')) || ""; // Extraer los datos del usuario del localStorage.
        let token = user.Token;
        localStorage.setItem('token', token);

        socket = io(process.env.REACT_APP_SOCKET_URL, {
            reconnection: true,
            reconnectionAttempts: Infinity,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            timeout: 20000,
            pingInterval: 25000,
            pingTimeout: 5000,
            path: process.env.REACT_APP_SOCKET_URL_PATH,
            query: { "Token": token }
        });

        socket.on('connect', () => {
            console.log('SOCKET CONECTADO CORRECTAMENTE');
            localStorage.setItem("connect", "true");
            isConnected = true;
            window.dispatchEvent(new Event('storage')); // Notificar a los listeners
        });

/*         socket.on('disconnect', (reason) => {
            console.log('EL SOCKET SE DESCONECTÓ:', reason);
            localStorage.setItem("connect", "false");
            isConnected = false;
            window.dispatchEvent(new Event('storage')); 
        });
 */
        socket.on('connect_error', (error) => {
            console.error('ERROR DE CONEXIÓN EN EL SOCKET:', error);
            localStorage.setItem("connect", "false");
            isConnected = false;
            window.dispatchEvent(new Event('storage')); 
        });

        socket.on('connect_timeout', (timeout) => {
            console.error('Tiempo de conexión agotado:', timeout);
            localStorage.setItem("connect", "false");
            isConnected = false;
            window.dispatchEvent(new Event('storage')); 
        });

        return socket;
    }
};

export const disconnectSocket = () => {
    if (socket) {
        console.log("Socket desconectado");
        localStorage.removeItem('token');
        socket.disconnect();
        socket = null;
        isConnected = false;
        localStorage.setItem("connect", "false");
        window.dispatchEvent(new Event('storage')); // Notificar a los listeners
    }
};

export const getSocket = () => {
    return socket;
};

export const socketIsConnected = () => {
    console.log("Estado actual del socket:", isConnected);
    return isConnected;
};
